import { render, staticRenderFns } from "./WidgetTipo.vue?vue&type=template&id=4f817092&scoped=true"
import script from "./WidgetTipo.vue?vue&type=script&lang=js"
export * from "./WidgetTipo.vue?vue&type=script&lang=js"
import style0 from "./WidgetTipo.vue?vue&type=style&index=0&id=4f817092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f817092",
  null
  
)

export default component.exports